import { openDB } from 'idb'

const DB_NAME = 'calendarEventsDB'
const STORE_NAME = 'events'

let dbPromise = openDB(DB_NAME, 1, {
  upgrade(db) {
    db.createObjectStore(STORE_NAME)
  }
})

const isOpen = async (db: any): Promise<boolean> => {
  let open = true
  try {
    await db.transaction('')
  } catch (err: any) {
    if (err?.name === 'InvalidStateError') {
      open = false
    }
  }
  return open
}

const getDB = async (retries = 5): Promise<any> => {
  if (!dbPromise || !(await isOpen(await dbPromise))) {
    if (retries === 0) {
      throw new Error('Failed to open database after multiple attempts')
    }
    dbPromise = openDB(DB_NAME, 1, {
      upgrade(db) {
        db.createObjectStore(STORE_NAME)
      }
    })
    return getDB(retries - 1)
  }
  return dbPromise
}
export const getEvent = async (key: string) => {
  const db = await getDB()
  const data = await db.get(STORE_NAME, key)
  return data ? JSON.parse(data.toString()) : null
}

export const setEvent = async (key: string, value: any) => {
  const db = await getDB()
  return db.put(STORE_NAME, JSON.stringify(value), key)
}

export const deleteEvent = async (key: string) => {
  const db = await getDB()
  return db.delete(STORE_NAME, key)
}

export const clearIndexedDB = async (): Promise<void> => {
  const db = await getDB()
  db.close()

  return new Promise((resolve, reject) => {
    const request = indexedDB.deleteDatabase(DB_NAME)
    request.onsuccess = () => {
      resolve()
    }
    request.onerror = (event) => {
      reject(event)
    }
    request.onblocked = async () => {
      await new Promise((resolve) => setTimeout(resolve, 100))
      await clearIndexedDB()
    }
  })
}
